import { Tooltip } from '@/components/tooltips';
import { useWorkspace } from '@/features/workspaces/hooks';
import { IconButton } from '@/lib/Buttons';
import { TrashIcon } from '@/lib/Icons';
import { Audience } from '@/models/audiences';
import { useGetAudienceDependenciesQueryQuery } from '@/services/endpoints/audiences';
import { isEmpty } from 'lodash';
import { FC, useMemo, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteAudienceModal } from './modals/DeleteAudienceModal';

type DeleteAudienceV2Props = {
  audience?: Audience;
};

export const DeleteAudienceV2: FC<DeleteAudienceV2Props> = ({ audience }) => {
  const workspace = useWorkspace();
  const { t } = useTranslation('audience_details');

  const { data } = useGetAudienceDependenciesQueryQuery({
    workspaceId: workspace.id,
    audienceId: audience?.id || '',
  });

  const audiences = data?.audiences || [];
  const disabledDelete = audiences && !isEmpty(audiences);

  const audiencesInTooltip = useMemo(() => audiences.map((audience) => audience.name).join(', '), [audiences]);
  const tooltipContent = disabledDelete ? `${t('settings.delete.cannot_delete_audience')}\n${audiencesInTooltip}` : '';

  const [isModalOpen, toggleModal] = useReducer((state) => !state, false);

  return (
    <>
      <div>
        <Tooltip className='border bg-white-100 text-xs text-primary-900' tooltipContent={tooltipContent}>
          <IconButton
            intent='tertiary'
            leadingIcon={<TrashIcon />}
            onClick={toggleModal}
            disabled={disabledDelete}
            text={t('settings.delete.delete_this_audience')}
          />
        </Tooltip>
      </div>
      {isModalOpen && <DeleteAudienceModal audience={audience} closeModal={toggleModal} />}
    </>
  );
};
